import React, { createContext, useState } from "react"

import { ScopedConfigurationsResponse } from "@tfg/types/types/communication-studio/configurations.types"
import { StylingParameters } from "@tfg/types/types/communication-studio/styling-parameters.types"

import { GetProductPageComponentsResponseDto } from "~/gen/api"

type DesignTokensEditorContextValue = {
  styleData: Partial<StylingParameters>
  setStyleData: React.Dispatch<React.SetStateAction<Partial<StylingParameters>>>
  resetStyleData: () => void
  errors: Partial<Record<string, string>>
  setErrors: React.Dispatch<
    React.SetStateAction<Partial<Record<string, string>>>
  >
  isDirty: boolean
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>
  configurations: ScopedConfigurationsResponse
  setConfigurations: React.Dispatch<
    React.SetStateAction<ScopedConfigurationsResponse>
  >
  productPageComponents: GetProductPageComponentsResponseDto[]
  setProductPageComponents: React.Dispatch<
    React.SetStateAction<GetProductPageComponentsResponseDto[]>
  >
}

export const DesignTokensEditorContext =
  createContext<DesignTokensEditorContextValue | null>(null)
type DesignTokensEditorProviderProps = {
  children: React.ReactNode
  initialStyleData: Partial<StylingParameters>
  initialConfigurations: ScopedConfigurationsResponse
  initialProductPageComponents: GetProductPageComponentsResponseDto[]
}

export const DesignTokensEditorProvider = ({
  children,
  initialStyleData,
  initialConfigurations,
  initialProductPageComponents,
}: DesignTokensEditorProviderProps) => {
  const [configurations, setConfigurations] =
    useState<ScopedConfigurationsResponse>(initialConfigurations)
  const [styleData, setStyleData] =
    useState<Partial<StylingParameters>>(initialStyleData)
  const [productPageComponents, setProductPageComponents] = useState<
    GetProductPageComponentsResponseDto[]
  >(initialProductPageComponents)
  const [errors, setErrors] = useState<Partial<Record<string, string>>>({})
  const [isDirty, setIsDirty] = useState(false)
  const resetStyleData = () => {
    setStyleData(initialStyleData)
  }

  return (
    <DesignTokensEditorContext.Provider
      value={{
        styleData,
        setStyleData,
        resetStyleData,
        errors,
        setErrors,
        isDirty,
        setIsDirty,
        configurations,
        setConfigurations,
        productPageComponents,
        setProductPageComponents,
      }}
    >
      {children}
    </DesignTokensEditorContext.Provider>
  )
}
